import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { BarChart3, Globe, Monitor } from "lucide-react";

export default function AnalyticsPage() {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/api/v1/analytics/stats").then(setStats).catch((e) => toast.error(e.message)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="animate-pulse space-y-4"><div className="h-8 bg-muted rounded w-40"/><div className="h-64 bg-muted rounded-xl"/></div>;

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Analytics</h1>
      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <div className="bg-card rounded-xl border border-border p-5">
          <p className="text-sm text-muted-foreground mb-1">Total Visits</p>
          <p className="text-3xl font-bold">{(stats?.totalVisits || 0).toLocaleString()}</p>
        </div>
        <div className="bg-card rounded-xl border border-border p-5">
          <p className="text-sm text-muted-foreground mb-1">Today</p>
          <p className="text-3xl font-bold">{(stats?.todayVisits || 0).toLocaleString()}</p>
        </div>
      </div>
      <div className="grid lg:grid-cols-2 gap-6">
        {stats?.browsers?.length > 0 && (
          <div className="bg-card rounded-xl border border-border p-5">
            <h2 className="font-semibold mb-4 flex items-center gap-2"><Monitor className="w-4 h-4 text-primary" /> Browsers</h2>
            <div className="space-y-2">{stats.browsers.map((b: any, i: number) => (
              <div key={i} className="flex items-center justify-between text-sm">
                <span>{b.browser_name || "Unknown"}</span>
                <span className="font-medium">{b.count}</span>
              </div>
            ))}</div>
          </div>
        )}
        {stats?.countries?.length > 0 && (
          <div className="bg-card rounded-xl border border-border p-5">
            <h2 className="font-semibold mb-4 flex items-center gap-2"><Globe className="w-4 h-4 text-primary" /> Countries</h2>
            <div className="space-y-2">{stats.countries.map((c: any, i: number) => (
              <div key={i} className="flex items-center justify-between text-sm">
                <span>{c.country || "Unknown"}</span>
                <span className="font-medium">{c.count}</span>
              </div>
            ))}</div>
          </div>
        )}
      </div>
    </div>
  );
}
